import { forwardRef } from 'react';

import Button, { ButtonProps } from 'ui/Button';

const ActionMenuTriggerButton = forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'variant'>
>((props, ref) => (
  <Button
    {...props}
    ref={ref}
    borderRadius="none"
    size="sm"
    css={{
      '&[data-state=open]': {
        background: 'green.800',
        color: 'white',
        _hover: {
          background: 'green.800',
          color: 'white',
        },
      },
    }}
    variant="neutral-ghost"
  />
));

export default ActionMenuTriggerButton;
